module.exports = __webpack_public_path__ + "img/bg-1.4b8dce61.jpg";